<script>
  import { Starvortraege } from "../Api/congress";
  import { operationStore, query } from "@urql/svelte";
  import Item from "./Starvortraege/Item.svelte";
  import Header from "../Component/Header.svelte";
  import CFAText from "../Component/CFAText.svelte";

  export let congressId;
  const widgetView = "starvortraege";

  let data = [];
  let inProgress = false;

  const congressStarvortraege = operationStore(Starvortraege, { congressId, widgetView });

  query(congressStarvortraege);

  congressStarvortraege.subscribe((storeObj) => {
    inProgress = storeObj.fetching;
    if (!inProgress && storeObj.data) {
      data = storeObj.data.starvortraegedata;
    }
  });
</script>

<Header {congressId} {...data} />

<h2 class="my-2.5 text-center">Vorträge der Starreferenten</h2>
<hr class="hr-gradient mb-2.5" />

<CFAText enable={data.cfaTextsteuerung == 1} />

{#if congressId >= 139}
  <div class="my-4 flex items-end justify-center bg-im-gray-200">
    <div class="flex-1 self-center p-4">
      <h3 class="text-xl font-light sm:text-3xl">Simultanübersetzung</h3>
      <p>
        <strong>Simultan Streaming Service</strong> - Kopfhörer nicht vergessen! Bitte beachten Sie, dass Sie hierfür <strong>Ihre eigenen Kopfhörer</strong> über Ihr Handy nutzen müssen.
        <strong>Es werden daher keine Kopfhörer mehr ausgegeben</strong>. Es wird keine App benötigt.
      </p>
    </div>
    <figure class="basis-52 pr-2 pt-2">
      <img class="max-w-full" src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/headphones_v3.png" alt="Mobiltelefon mit Kopfhörern" />
    </figure>
  </div>
{/if}

{#each data?.eventlist || [] as item}
  <Item {item} />
{/each}
